export async function getStatesFromCountryUseCase(country, addressLocationsRepository) {
  
    const result = await addressLocationsRepository.get_state_from_country(country);

    if (result.status == 200) return result.data;
}